import { gql } from '@apollo/client';

import { JobStatus } from 'shared/models/job';

export interface EffortJob {
    id: string;
    title: string;
    status: JobStatus;
    accountManager: {
        id: string;
        name: string;
    };
    assignee: {
        id: string;
        name: string;
    };
    client: {
        id: string;
        name: string;
    };
}

// Active jobs always appear (even with zero activity); paused/archived jobs appear only
// when they received activity in the selected period
export const EFFORT_JOBS = gql`
    query EffortJobs(
        $jobTypes: [String!]!
        $excludeClientIds: [String!]!
        $kinds: [String!]!
        $startDate: date!
        $endDate: date!
    ) {
        jobs(
            where: {
                jobType: { _in: $jobTypes }
                clientId: { _nin: $excludeClientIds }
                _or: [
                    { status: { _eq: 1 } }
                    { activity_metrics: { kind: { _in: $kinds }, date: { _gte: $startDate, _lte: $endDate } } }
                ]
            }
            order_by: [{ client: { name: asc } }, { title: asc }]
        ) {
            id
            title
            status
            accountManager {
                id
                name(path: "full")
            }
            assignee: recruiter {
                id
                name(path: "full")
            }
            client {
                id
                name
            }
        }
    }
`;
